<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>¿Cuándo se requiere hacer monitoreo de atmósferas?</h1>    
            <!-- <h2 class="animated bounceIn dura-2">Personas autorizadas</h2> -->
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
        <p>La prueba de gases debe realizarse antes de la ejecución de los trabajos, definiendo previamente los puntos del muestreo, de manera que sean representativos de las condiciones reinantes y de acuerdo con las características del trabajo. </p>
        <span><strong>¿Cuándo evaluar atmósferas?</strong></span>
        <p>La evaluación de atmósferas se debe realizar en los siguientes momentos: </p>
        <v-layout wrap row  align-center text-xs-center pb-5 mt-4 class="cont_page">
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-2" src="@/assets/unidad2/pantalla-1-1.png" height="60" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-3">Siempre que se realicen trabajos con la posibilidad de tener deficiencia o suficiencia de oxígeno, gas explosivo o tóxico en el ambiente de trabajo.</p>
                    <hr class="animated bounceIn dura-3">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-4" src="@/assets/unidad2/pantalla-1-2.png" height="65" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-5 pt-4">Siempre que se realicen trabajos en espacios confinados.</p>
                    <hr class="animated bounceIn dura-5">
                </v-flex>
                <v-flex sm12 md12></v-flex>
    
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-6" src="@/assets/unidad2/pantalla-1-3.png" height="65" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-7 pt-4">Siempre que se desarrollen trabajos en excavaciones donde se configure un espacio confinado.</p>
                    <hr class="animated bounceIn dura-7">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-8" src="@/assets/unidad2/pantalla-1-3-1.png" height="65" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-9 pt-4">Cada vez que se especifique en el análisis de riesgo, procedimiento/instructivo de trabajo. </p>
                    <hr class="animated bounceIn dura-9">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-10" src="@/assets/unidad2/pantalla-1-3-2.png" height="65" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-11 pt-4">Siempre que se presenten emergencias con materiales peligrosos  (MATPEL/HAZMAT).</p>
                    <hr class="animated bounceIn dura-11">
                </v-flex>
                <v-flex sm12 md12></v-flex>
                <v-flex xs12 sm7 md2 class="text-xs-center">
                    <img class="animated bounceIn dura-12" src="@/assets/unidad2/pantalla-1-3-3.png" height="35" alt="">
                </v-flex>
                <v-flex xs12 sm9 md6>
                    <p class="animated bounceIn dura-13 pt-4">Siempre que se cuente con un área clasificada e identificada.</p>
                    <hr class="animated bounceIn dura-13">
                </v-flex>
                <v-flex sm12 md12></v-flex>
            </v-layout>
        <!-- items imagen con texto en movil -->
        <v-flex xs12 sm9 md7 mt-4  class="text-xs-left" v-show="$vuetify.breakpoint.xs">
        <div  class="container-module my-3" v-for="n in length" :key="`card-${n}`" align-center>
          <div class="animated bounceIn dura-2">
            <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-1-'+n+'.png')" alt="">
          </div>
          <div class="modulo-name">
            <p v-html="items[n-1]"></p>
          </div>
          <hr class="hr" style="color: #2368D9;" />
        </div>
        </v-flex>
          <p>Ten en cuenta que las condiciones ambientales son cambiantes, por lo tanto, la frecuencia del monitoreo debe establecerse claramente durante la planeación del trabajo.</p>
          <p>El monitoreo de atmósferas es fundamental, por lo tanto, es muy importante asegurar los aspectos relacionados con las personas y con los equipos que se utilizan para realizar estas pruebas.</p>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      

    }
  },
  mounted(){
    setTimeout(() => {
      this.$store.commit('nextShow', true)
    }, 5000);
  }
  
  
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.icon-titulo{
  content: url('../../assets/imagenes_compartidas/icon-titulo.png');
  width: 0.7em;
}
hr {
    height: 2px;
    background-color: $color-complement-one;
    border: none;
    margin-bottom: 1em;
}
.caja_texto{
  background:#ffff;
  padding: 5px 5px 5px 5px;
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 15px;
    height: 15px;
  }
}
.flip-item{
  position: relative;
  width: 100%;
  height:auto;
  padding: 10px;
  p{
    text-align: center;
  }
  .pb{
    color: $color-secondary;
    font-family: FontBase-Bold;
  }
  @media screen and (max-width: 330px) {
    img{
      width: 150px;
    }
    
  }
}
.items{
  font-size: 13.6px; 
} 
.container-module{
  @media screen and (max-width: 500px){ 
    text-align: center;
    img{
      width: 25%;
    }
    .modulo-name{
      width: 100%; 
      padding-left: 0px;
    }
    
  } 
}
@media screen and (max-width: 500px){
.contenido2{
  display: flex;
  flex-direction: column;
  align-items: center;

}
}
</style>

